import React from "react";
import { SwarovskiOptikPageRenderer } from "./swarovski-optik-page-renderer/swarovski-optik-page-renderer";
import { SwarovskiPageDataFrontend } from "@swo/storefront";
import { PageContexts } from "../global/PageContexts";
import isEqual from "react-fast-compare";
import { PublicConfigurationT } from "@swo/shared";
import { CommonRouteElements } from "./common-route-elements";
import { Global } from "@emotion/react";
import { getGlobalFontStyles } from "../styles/styles-global";

const RawLoadedStorefrontPages: React.FC<{
  pageData: SwarovskiPageDataFrontend;
  mode: "preview" | "published";
  intercom: PublicConfigurationT["integrations"]["intercom"];
  children?: React.ReactNode;
  withDebugStyles?: boolean;
  config: PublicConfigurationT;
}> = props => {
  return (
    <>
      <Global styles={getGlobalFontStyles(props.pageData.locale.language.isoCode)} />
      <PageContexts pageData={props.pageData} withDebugStyles={props.withDebugStyles}>
        <CommonRouteElements pageData={props.pageData} intercom={props.intercom} />
        <SwarovskiOptikPageRenderer data={props.pageData} mode={props.mode} config={props.config} />
      </PageContexts>

      {props.children}
    </>
  );
};

export const LoadedStorefrontPages = React.memo(RawLoadedStorefrontPages, isEqual);
